import React, { useEffect, useState } from 'react';
import avtar1 from '../../assets/images/user/avatar-1.jpg';
import { Link } from 'react-router-dom';
import { deleteData, getData, imgUrl, patchData,deleteDataNew } from '../Services/api';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Pagination from '../Services/Pagination';

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [perPage, setPerPage] = useState(10); // items per page
    const [search, setSearch] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);


    const handleSelectAll = (e) => {
    if (e.target.checked) {
        const allUserIds = users.map((user) => user.id);
        setSelectedUsers(allUserIds);
    } else {
        setSelectedUsers([]);
    }
};

const handleSelectUser = (userId) => {
    setSelectedUsers((prevSelected) => {
        if (prevSelected.includes(userId)) {
            return prevSelected.filter((id) => id !== userId);
        } else {
            return [...prevSelected, userId];
        }
    });
};


const handleBulkDelete = () => {
    Swal.fire({
        title: "Are you sure?",
        text: `You are about to delete ${selectedUsers.length} users!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete all!",
        cancelButtonText: "Cancel",
    }).then(async (result) => {
        if (result.isConfirmed) {
            try {
                console.log(selectedUsers)
                const res = await deleteDataNew(`users/delete-multiple`, { ids: selectedUsers }); 
                // 👆 backend should accept an array of IDs

                if (res.status) {
                    toast.success(res.message || "Users deleted successfully!");
                    setSelectedUsers([]);
                    fetchUsers();
                }
            } catch (error) {
                console.error("Error deleting users:", error);
                toast.error("Failed to delete users!");
            }
        }
    });
};



    const fetchUsers = async (pageNumber = page, searchQuery = search) => {
        try {
            const res = await getData(`/users/all?page=${pageNumber}&perPage=${perPage}&search=${searchQuery}`);
            if (res.status) {
                setUsers(res.data || []);
                setPage(res.pagination.page || 1);
                setPages(res.pagination.totalPages || 1);
                setTotal(res.pagination.total || 0);
            }
        } catch (error) {
            console.log("Error fetching users:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, perPage, search]); // refetch when page, perPage or search changes

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            setPage(pageNumber);
        }
    };

    const handleDelete = (userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/users/delete/${userId}`);
                    if (res.status) {
                        toast.success(res.message);
                        fetchUsers();
                    }
                } catch (error) {
                    console.log("Error deleting user:", error);
                }
            }
        });
    };

    const handleStatusChange = async (userId, status) => {
        const newStatus = status === 'active' ? 'inactive' : 'active';
        try {
            const res = await patchData(`/users/toggle-status/${userId}`, { status: newStatus });
            if (res.status) {
                toast.success(res.message);
                fetchUsers();
            }
        } catch (error) {
            console.log("Error changing status:", error);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/users/user-list">Salesmen</Link></li>
                                    <li className="breadcrumb-item" aria-current="page">Salesmen</li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Salesmen</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="card table-card">
                            <div className="card-body">
                                <div className="d-sm-flex align-items-center p-4">
                                    <ul className="list-inline me-auto my-1">
                                        <li className="list-inline-item">
                                            <div className="form-search">
                                                <i className="fas fa-search" />
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder="Search user"
                                                    value={search}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value);
                                                        setPage(1); // reset page when searching
                                                    }}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="text-end p-4 pb-sm-2">
                                        <Link to="/users/add-user" className="btn btn-primary d-inline-flex align-item-center">
                                            <i className="fas fa-plus f-18 mx-2" /> Add Salesmen
                                        </Link>
                                        {selectedUsers.length > 0 && (
    <button
        className="btn btn-danger ms-2"
        onClick={handleBulkDelete}
    >
        <i className="fas fa-trash mx-2" /> Delete Selected
    </button>
)}
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-hover" id="pc-dt-simple">
                                        <thead>
                                            <tr>
                                                <th>
                                                <input
                                                type="checkbox"
                                                checked={selectedUsers.length === users.length && users.length > 0}
                                                onChange={handleSelectAll}
                                                />
                                                </th>
                                                <th>S.No.</th>
                                                <th>Salesmen Details</th>
                                                <th>ID</th>
                                                <th>Salesmen Name</th>
                                                <th>Contact Number</th>
                                                <th>Manager Name</th>
                                                <th>Role</th>
                                                <th>Status</th>
                                                <th className="text-center">Actions</th>
                                                <th className="text-center">Log</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length > 0 ? users.map((user, index) => (
                                                <tr key={user.id}>
                                                <td> <input
        type="checkbox"
        checked={selectedUsers.includes(user.id)}
        onChange={() => handleSelectUser(user.id)}
    />
    </td>
                                                    <td>{index + 1 + (page - 1) * perPage}</td>
                                                    <td>
                                                        <div className="row">
                                                            <div className="col-auto">
                                                                <img
                                                                    src={user.profile_image ? `${imgUrl}${user.profile_image}` : avtar1}
                                                                    alt="user-image"
                                                                    className="wid-40 rounded-circle"
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <h6 className="mb-0">{user.username}</h6>
                                                                <p className="text-muted f-12 mb-0">{user.email}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{user.id}</td>
                                                    <td>{user.username}</td>
                                                    <td>{user.mobile}</td>
                                                    <td>{user.manager_name}</td>
                                                    <td>{user.role}</td>
                                                    <td>
                                                        <div className="form-check form-switch">
                                                            <input className="form-check-input" type="checkbox" checked={user.status} onChange={() => handleStatusChange(user.id)} role="switch" id="switchCheckDefault" />
                                                            {/* <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={user.status === 'active'}
                                                                onChange={() => handleStatusChange(user.id, user.status)}
                                                                role="switch"
                                                            /> */}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <ul className="list-inline me-auto mb-0">
                                                            <li className="list-inline-item align-bottom" title="View">
                                                                <Link to={`/users/view-user/${user.id}`} className="avtar avtar-xs btn-link-secondary btn-pc-default">
                                                                    <i className="fas fa-eye f-18" />
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item align-bottom" title="Edit">
                                                                <Link to={`/users/update-user/${user.id}`} className="avtar avtar-xs btn-link-success btn-pc-default">
                                                                    <i className="fas fa-edit f-18" />
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item align-bottom" title="Delete">
                                                                <button onClick={() => handleDelete(user.id)} className="avtar avtar-xs btn-link-danger btn-pc-default">
                                                                    <i className="fas fa-trash f-18" />
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                    <td className="text-center">
                                                        <Link to={`/users/call-log/${user.id}`} className="btn btn-success me-2">Call Log</Link>
                                                        <Link to={`/users/visit-log/${user.id}`} className="btn btn-success">Visit Log</Link>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td className='text-center' colSpan={10}><strong>No Users Found.</strong></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                    <div className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {Math.min(page * perPage, total)} of {total} entries
                                    </div>
                                    <Pagination page={page} pages={pages} onPageChange={handlePageChange} />
                                    
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserList;
